import React, { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import './NumbersMax.scss';
import formatOdds from 'src/utils/formatOdds';
import { RootState } from 'src/configs/store';
import BallsContainer from 'src/components/Betslip/NumberBet/Components/BallsContainer/BallsContainer';
import { formatAmountToFixed } from 'src/utils/utils';
import classNames from 'classnames';

interface Props {
  selectedNumbers: any,
  marketName: string,
  betIndex: number,
  odds: number,
  permutationsCount: number,
  addPadding: boolean,
  sameDrum: boolean,
  isRacing: boolean
  jsonLabel: any
  type: string,
  outcome: string
  numbersToPredictCount: number,
  stake:  {
    stake: number,
    maximumProfit: number
  }
}


function NumbersMax({
  marketName,
  betIndex,
  odds,
  selectedNumbers,
  sameDrum,
  permutationsCount,
  type,
  outcome,
  isRacing=false,
  jsonLabel,
  numbersToPredictCount=null,
  stake
}: Props) {
  const selectedOddsType = useSelector((state: RootState) => state.odds.selectedOddsType);
  const numbersContainer = useRef(null);
  const { t } = useTranslation();

  const [wrap, setWrap] = useState(false);
  const detectWrap = () =>  {
    if (numbersContainer.current && numbersContainer.current.clientHeight >= 145){
      setWrap(true);
    }
  };

  useEffect(() => {
    detectWrap();
  }, [numbersContainer.current]);

  return (
    <div className="numbers-max">
      <div className={
        classNames({
          'numbers-max__line': true,
          'numbers-max__line--big':marketName.length > 24
        })
      }
      >
        <div className={
          classNames({
            'numbers-max__market-container': true,
            'numbers-max__market-container--big': marketName.length > 24
          })
        }
        >
          <span className="numbers-max__index">{ `${ betIndex }. ` }</span>
          <span className={
            classNames({
              'numbers-max__market': true,
              'numbers-max__market--big': marketName.length > 24
            })
          }
          >{ marketName }</span>
          { type === 'sport' && <span className="numbers-max__market-outcome">{ outcome }</span> }
          {
            type === 'racing' && numbersToPredictCount && numbersToPredictCount === 1 &&
          <span className="numbers-max__market-outcome">{ jsonLabel }</span>
          }
        </div>
        {
          !wrap && <div className="numbers-max__numbers-container" ref={ numbersContainer }>
            { !isRacing && <BallsContainer anyNumbers={ selectedNumbers } sameBallset={ sameDrum } big /> }
            {
              permutationsCount && permutationsCount > 1 &&
         <div className="numbers-max__combo">{ `${ t('betslip.combo') }: ${ permutationsCount } ${ t('secondScreen.bets') }` }</div>
            }
          </div>
        }
        <div className={
          classNames({
            'numbers-max__stake': true,
            'numbers-max__stake--full': wrap
          })
        }
        >
          {
            +odds == odds ? `ZAR ${ formatAmountToFixed(+stake?.stake * permutationsCount, 100, true) } X
        ${ formatOdds(odds, selectedOddsType) } = ${ formatAmountToFixed(+stake?.maximumProfit, 100, true) }` : 'TP'
          }
        </div>
      </div>
      {
        wrap && <div className="numbers-max__numbers-container numbers-max__numbers-container--full">
          { !isRacing && <BallsContainer anyNumbers={ selectedNumbers } sameBallset={ sameDrum } big /> }
          {
            permutationsCount && permutationsCount > 1 &&
         <div className="numbers-max__combo numbers-max__combo--left">
           { `${ t('betslip.combo') }: ${ permutationsCount } ${ t('secondScreen.bets') }` }
         </div>
          }
        </div>
      }
    </div>
  );
}

export default NumbersMax;
